/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/build/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(378);


/***/ },

/***/ 378:
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(379);
	__webpack_require__(380);
	__webpack_require__(381);
	__webpack_require__(382);
	
	var $contact_links = document.querySelectorAll('a');
	
	for (var i = 0; i < $contact_links.length; i++) {
	  $contact_links[i].onclick = (function (hash) {
	    return function () {
	      ga('send', 'event', 'link', 'click', 'view-article');
	    }
	  })($contact_links[i].hash);
	}


/***/ },

/***/ 379:
/***/ function(module, exports) {

	(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
	  (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
	  m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
	})(window,document,'script','//www.google-analytics.com/analytics.js','ga');
	ga('create', 'UA-50780056-1', 'hackthenorth.com');
	ga('send', 'pageview', { 'page': location.pathname + location.search + location.hash});
	
	var $facebookIcon = document.querySelector('.facebook-icon');
	var $twitterIcon = document.querySelector('.twitter-icon');
	var $anchors = document.querySelectorAll('.navbar-link, .menu-item');
	var $footerLink = document.querySelector('.footer-contact a');
	
	$facebookIcon.onclick = function (){
	  ga('send', 'event', 'link', 'click', 'view-facebook');
	}
	$twitterIcon.onclick = function (){
	  ga('send', 'event', 'link', 'click', 'view-twitter');
	}
	
	for (var i = 0; i < $anchors.length; i++) {
	  if (!$anchors[i].hash){
	    continue;
	  }
	  $anchors[i].onclick = (function (hash) {
	    return function () {
	      ga('send', 'pageview', location.pathname + hash);
	    }
	  })($anchors[i].hash);
	}
	
	$footerLink.onclick = function () {
	  ga('send', 'event', 'link', 'click', 'footer-email');
	}


/***/ },

/***/ 380:
/***/ function(module, exports) {

	document.addEventListener("DOMContentLoaded", function(event) {
	  var $pressTitle = document.querySelector('.press-title') || document.querySelector('.hero-logo')
	  var $pressSubTitle = document.querySelector('.press-sub-title') || document.querySelector('.hero-subtitle')
	  var $stars = document.querySelectorAll('.star-wrapper')
	  var $starsContainer = document.querySelector('.stars-container')
	  var notIE9 = "classList" in document.createElement("_")
	
	  var height = $starsContainer ? $starsContainer.offsetHeight : 480
	  var width = document.documentElement.clientWidth
	  var titleBuffer = 10
	  updateStars()
	
	  window.onresize = function (){
	    if (width !== document.documentElement.clientWidth){
	      width = document.documentElement.clientWidth
	      updateStars()
	    }
	  }
	
	  function blink(){
	    if(notIE9){
	      var $smallStars = document.querySelectorAll('.star-wrapper .small-star')
	      var randomStarIndex = getRandomInt(0, $smallStars.length)
	      setTimeout(function() {
	        $smallStars[randomStarIndex].classList.remove('blink')
	      }, 1900)
	      $smallStars[randomStarIndex].classList.add('blink')
	      setTimeout(blink, getRandomInt(2000, 10000))
	    }
	  }
	  blink()
	
	  function getRandomInt(min, max) {
	    return Math.floor(Math.random() * (max - min)) + min;
	  }
	
	  function updateStars(){
	    height = $starsContainer ? $starsContainer.offsetHeight : 480
	    var pressTitleRec = getPosition($pressTitle)
	    var pressSubTitleRec = getPosition($pressSubTitle)
	    for (var i = 0; i < $stars.length; i++) {
	      var randomWidth = getRandomInt(width > 865 ? 80 : 10, width - (width > 865 ? 80 : 10))
	      var randomHeight = getRandomInt(80, height - 20)
	      if (randomHeight < pressTitleRec.y - titleBuffer ||
	          randomHeight > pressSubTitleRec.y + pressSubTitleRec.height + titleBuffer ||
	          randomWidth < pressTitleRec.left - titleBuffer ||
	          randomWidth > pressTitleRec.right + titleBuffer) {
	        $stars[i].style.left = randomWidth + 'px'
	        $stars[i].style.top = randomHeight + 'px'
	      } else {
	        i--
	      }
	    };
	  }
	
	  function getPosition(element) {
	    var xPosition = 0;
	    var yPosition = 0;
	    var boundRec = element.getBoundingClientRect()
	    var left = boundRec.left
	    var right = boundRec.right
	    var height = boundRec.height
	    var i = 0
	    while(i < 2) {
	      xPosition += (element.offsetLeft - element.scrollLeft + element.clientLeft)
	      yPosition += (element.offsetTop - element.scrollTop + element.clientTop)
	      element = element.offsetParent
	      i++
	    }
	    return { x: xPosition, y: yPosition, left:left, right: right, height: height}
	  }
	});


/***/ },

/***/ 381:
/***/ function(module, exports) {

	var $menuToggle = document.querySelector('.navbar-toggle');
	var $menu = document.querySelector('.menu');
	var $menuItems = document.querySelectorAll('.menu-item');
	
	window.onhashchange = function (){
	  $menu.className = 'menu menu-no-transition';
	}
	
	for (var i = $menuItems.length - 1; i >= 0; i--) {
	  $menuItems[i].onclick = function (){
	    window.location.href='/#home';
	  }
	};
	
	$menuToggle.onclick = function(){
	  if($menu.className === 'menu active'){
	    $menu.className = 'menu';
	  } else {
	    $menu.className = 'menu active';
	  }
	}


/***/ },

/***/ 382:
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }

/******/ });


/** WEBPACK FOOTER **
 ** js/faq.js
 **/